import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Normtider } from '../../../timetrack/store/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NormtiderService {

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient) {}

    getByUserAndYear(mid: number, year: number): Observable<Normtider[]> {
        return this.http.get<Normtider[]>(
            `[api]/model/normtider/byUserAndYear/${mid}/${year}`,
            this.httpOptions
        );
    }

    create(entry: Partial<Normtider>): Observable<Normtider> {
        return this.http.post<Normtider>(
            `[api]/model/normtider`,
            entry,
            this.httpOptions
        );
    }

    update(id: number, timer?: number | null, kode?: number | null): Observable<Normtider> {
        const patchDoc = [];

        if (timer !== undefined) {
            patchDoc.push({ op: 'replace', path: '/timer', value: timer });
        }

        if (kode !== undefined) {
            patchDoc.push({ op: 'replace', path: '/kode', value: kode });
        }

        return this.http.patch<Normtider>(
            `[api]/model/normtider/${id}`,
            patchDoc
        );
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(
            `[api]/model/normtider/${id}`,
            this.httpOptions
        );
    }

    bulkUpsert(entries: Partial<Normtider>[]): Observable<Normtider[]> {
        return this.http.post<Normtider[]>(
            `[api]/model/normtider/bulk`,
            entries,
            this.httpOptions
        );
    }
}
